import { useCreateSiteControllerSettingBeds24FormModel } from "../use-create-model/use-create-model";

import type { SiteControllerSettingBaseFormModel } from "../../../base/type";
import type { SiteControllerSettingBaseFormModelOnSetViewModelType } from "../../../base/use-case/use-create-model/use-create-model";

type Props = {
	baseViewModel: SiteControllerSettingBaseFormModel["ViewModel"];
	onSetViewModel: SiteControllerSettingBaseFormModelOnSetViewModelType;
};

export const useInitialized = ({ baseViewModel, onSetViewModel }: Props) => {
	return {
		...useCreateSiteControllerSettingBeds24FormModel({ viewModel: baseViewModel, onSetViewModel }),
	};
};
